// Import auth utilities
import { checkResponseStatus } from '../utils/authUtils';

// Helper function to get token - avoids circular dependency
const getAuthToken = () => {
    // Try to get from localStorage first (fallback)
    return localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
};

export async function fetchAdmins(page = 1, limit = 15) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();
    const headers = {
        'Content-Type': 'application/json',
    };
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    const url = `${API_BASE_URL}api/v1/dashboard/permission/admins?page=${page}&limit=${limit}`;
    console.log('Making fetch admins request to:', url);

    const response = await fetch(url, {
        method: 'GET',
        headers,
    });

    checkResponseStatus(response);

    if (!response.ok) {
        let errorMessage = 'Failed to fetch admins';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (e) {
            const errorText = await response.text();
            console.error('Non-JSON response:', errorText);
            errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
    }

    return response.json();
}
export async function createAdmin(adminData) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();
    const headers = {
        'Content-Type': 'application/json',
    };
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    // Use the provided role_id from adminData (now dynamic)
    const adminPayload = {
        ...adminData
    };

    const url = `${API_BASE_URL}api/v1/dashboard/permission/create`;
    console.log('Making create admin request to:', url);

    const response = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(adminPayload),
    });

    checkResponseStatus(response);

    if (!response.ok) {
        let errorMessage = 'Failed to create admin';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (e) {
            const errorText = await response.text();
            console.error('Non-JSON response:', errorText);
            errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
    }

    return response.json();
}

export async function updateAdminPermissions(adminId, permissions) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();
    const headers = {
        'Content-Type': 'application/json',
    };
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    const url = `${API_BASE_URL}api/v1/dashboard/admin/${adminId}/permissions`;
    console.log('Making update admin permissions request to:', url);

    const response = await fetch(url, {
        method: 'PUT',
        headers,
        body: JSON.stringify({ permissions }),
    });

    checkResponseStatus(response);

    if (!response.ok) {
        let errorMessage = 'Failed to update admin permissions';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (e) {
            const errorText = await response.text();
            console.error('Non-JSON response:', errorText);
            errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
    }

    return response.json();
}

export async function deleteAdmin(adminId) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();
    const headers = {
        'Content-Type': 'application/json',
    };
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    const url = `${API_BASE_URL}api/v1/dashboard/permission/delete/${adminId}`;
    console.log('Making delete admin request to:', url);

    const response = await fetch(url, {
        method: 'DELETE',
        headers,
    });

    checkResponseStatus(response);

    if (!response.ok) {
        let errorMessage = 'Failed to delete admin';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (e) {
            const errorText = await response.text();
            console.error('Non-JSON response:', errorText);
            errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
    }

    return response.json();
} export async function toggleAdminStatus(adminId, isActive) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();
    const headers = {
        'Content-Type': 'application/json',
    };
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    const url = `${API_BASE_URL}api/v1/dashboard/admin/${adminId}/status`;
    console.log('Making toggle admin status request to:', url);

    const response = await fetch(url, {
        method: 'PUT',
        headers,
        body: JSON.stringify({ is_active: isActive }),
    });

    checkResponseStatus(response);

    if (!response.ok) {
        let errorMessage = 'Failed to toggle admin status';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (e) {
            const errorText = await response.text();
            console.error('Non-JSON response:', errorText);
            errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
    }

    return response.json();
}

export async function fetchRoles() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();
    const headers = {
        'Content-Type': 'application/json',
    };
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    const url = `${API_BASE_URL}api/v1/dashboard/permission/list-role`;
    console.log('Making fetch roles request to:', url);

    const response = await fetch(url, {
        method: 'GET',
        headers,
    });

    checkResponseStatus(response);

    if (!response.ok) {
        let errorMessage = 'Failed to fetch roles';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (e) {
            const errorText = await response.text();
            console.error('Non-JSON response:', errorText);
            errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
    }

    return response.json();
}

export async function updateAdminRole(adminId, roleId) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();
    const headers = {
        'Content-Type': 'application/json',
    };
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    const url = `${API_BASE_URL}api/v1/dashboard/permission/update/${adminId}`;
    console.log('Making update admin role request to:', url);

    const response = await fetch(url, {
        method: 'PATCH',
        headers,
        body: JSON.stringify({ role_id: roleId }),
    });

    checkResponseStatus(response);

    if (!response.ok) {
        let errorMessage = 'Failed to update admin role';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (e) {
            const errorText = await response.text();
            console.error('Non-JSON response:', errorText);
            errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
    }

    return response.json();
}

// New function to update all admin data
export async function updateAdmin(adminId, adminData) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();
    const headers = {
        'Content-Type': 'application/json',
    };
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    const url = `${API_BASE_URL}api/v1/dashboard/permission/update/${adminId}`;
    console.log('Making update admin request to:', url);

    const response = await fetch(url, {
        method: 'PATCH',
        headers,
        body: JSON.stringify(adminData),
    });

    checkResponseStatus(response);

    if (!response.ok) {
        let errorMessage = 'Failed to update admin';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (e) {
            const errorText = await response.text();
            console.error('Non-JSON response:', errorText);
            errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
    }

    return response.json();
}

export async function fetchPermissions() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();
    const headers = {
        'Content-Type': 'application/json',
    };
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    const url = `${API_BASE_URL}api/v1/dashboard/permission/list`;
    console.log('Making fetch permissions request to:', url);

    const response = await fetch(url, {
        method: 'GET',
        headers,
    });

    checkResponseStatus(response);

    if (!response.ok) {
        let errorMessage = 'Failed to fetch permissions';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (e) {
            const errorText = await response.text();
            console.error('Non-JSON response:', errorText);
            errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
    }

    return response.json();
}

export async function fetchAdminPermissions(roleId) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();
    const headers = {
        'Content-Type': 'application/json',
    };
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    const url = `${API_BASE_URL}api/v1/dashboard/permission/list-admin-permission?role_id=${roleId}`;
    console.log('Making fetch admin permissions request to:', url);

    const response = await fetch(url, {
        method: 'GET',
        headers,
    });

    checkResponseStatus(response);

    if (!response.ok) {
        let errorMessage = 'Failed to fetch admin permissions';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (e) {
            const errorText = await response.text();
            console.error('Non-JSON response:', errorText);
            errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
    }

    return response.json();
}

export async function updatePermissions(permissionIds) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();
    const headers = {
        'Content-Type': 'application/json',
    };
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    const url = `${API_BASE_URL}api/v1/dashboard/permission/update-permission`;
    console.log('Making update permissions request to:', url);

    const requestBody = {
        role_id: "6884985f6b41c86db0459611", // Fixed role_id as specified
        permission_ids: permissionIds
    };

    const response = await fetch(url, {
        method: 'PATCH',
        headers,
        body: JSON.stringify(requestBody),
    });

    checkResponseStatus(response);

    if (!response.ok) {
        let errorMessage = 'Failed to update permissions';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (e) {
            const errorText = await response.text();
            console.error('Non-JSON response:', errorText);
            errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
    }

    return response.json();
}
